import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { noticeStore } from '../stores'
import { SubHeaderComponent } from './sub-header'
import { notify } from './notify'
import { historyLinkProps } from './history'
import * as bookmark from '../bookmark'
import { PublisherDisplayStr, PublisherStr } from '../../../common/define'

@observer
export class BookmarksComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      cachedPosts: bookmark.list(),
      expanded: null,
      exportedText: '',
      importInput: '',
      message: '',
    }
  }

  closeModal() {
    if (window.UIkit && window.UIkit.modal) {
      const modal = window.UIkit.modal('#bookmark-io-modal')
      if (modal) {
        modal.hide()
      }
    }
  }

  // resetModalState 는 모달을 열 때마다 이전 입력·펼침 상태를 비운다.
  // 모달은 일회 작업이라 재열림 시 초기화가 관행 — 잔존 expanded 로 펼침 토글이 어긋나던 버그도 함께 막는다.
  resetModalState() {
    this.setState({ expanded: null, exportedText: '', importInput: '', message: '' })
  }

  // onExportClick 은 내보내기 액션을 펼치며 목록을 클립보드에 복사한다.
  // progressive disclosure — 클릭 시 JSON 박스를 펼쳐 무엇을 복사했는지 보여준다.
  async onExportClick() {
    if (this.state.expanded === 'export') {
      this.setState({ expanded: null })
      return
    }
    const text = bookmark.exportText()
    this.setState({ expanded: 'export', exportedText: text, message: '' })
    try {
      await navigator.clipboard.writeText(text)
      notify('클립보드에 복사됐어요', 'success')
    } catch (e) {
      this.setState({ message: '자동 복사가 안 됐어요. 아래 텍스트를 길게 눌러 직접 복사하세요' })
    }
  }

  // onImportClick 은 가져오기 입력 박스를 펼치거나 접는다 (progressive disclosure).
  onImportClick() {
    this.setState({
      expanded: this.state.expanded === 'import' ? null : 'import',
      message: '',
    })
  }

  onImport() {
    const text = (this.state.importInput || '').trim()
    if (!text) {
      this.setState({ message: '가져올 목록 텍스트를 붙여넣으세요' })
      return
    }
    try {
      const added = bookmark.importText(text)
      // 성공: 목록을 갱신하고 토스트로 결과를 알린 뒤 모달을 닫는다 (뒤 목록에 즉시 반영됨).
      this.setState({ cachedPosts: bookmark.list(), importInput: '', message: '', expanded: null })
      notify(0 < added ? `${added}개 가져왔습니다` : '새로 추가된 글이 없습니다 (모두 중복)', 'success')
      this.closeModal()
    } catch (e) {
      // 실패: 모달을 유지하고 에러를 인라인으로 표시해 수정·재시도하게 한다.
      this.setState({ message: `가져오기 실패: ${e.message}` })
    }
  }

  onReset() {
    const n = bookmark.count()
    if (n <= 0) {
      this.setState({ message: '비울 목록이 없습니다' })
      return
    }
    // 파괴적이라 확인을 받고, 되돌리려면 먼저 내보내기 하도록 안내한다.
    if (!window.confirm(`다시보기 목록 ${n}개를 모두 지웁니다. 되돌릴 수 없어요 (필요하면 먼저 내보내기 하세요). 계속할까요?`)) {
      return
    }
    try {
      bookmark.clear()
    } catch (e) {
      this.setState({ message: '저장 공간이 부족해 비우지 못했습니다' })
      return
    }
    this.setState({ cachedPosts: bookmark.list(), message: '', expanded: null })
    notify(`${n}개를 지웠습니다`, 'success')
    this.closeModal()
  }

  render() {
    return (
      <div id="notices">
        <SubHeaderComponent isBookmark={true} />

        <div className="uk-flex uk-flex-right uk-margin-small-top uk-margin-small-bottom">
          <button className="uk-button uk-button-default uk-button-small" type="button" uk-toggle="target: #bookmark-io-modal" onClick={() => this.resetModalState()}>목록 관리</button>
        </div>

        <ul className="uk-list uk-list-divider uk-text-middle">
          {
            this.state.cachedPosts.map((post, i) =>
              <li data-post-id={i} className="post" key={i}>
                <BookmarkComponent post={post} postIndex={i} />
              </li>)
          }
          {
            this.state.cachedPosts.length <= 0 &&
            <div className="uk-text-center uk-margin"> no data </div>
          }
        </ul>
        {
          noticeStore.notices.length <= 0 &&
          <div className="uk-text-center uk-margin">
            no notice
        </div>
        }

        <div id="bookmark-io-modal" uk-modal="uk-modal">
          <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
            <button className="uk-modal-close-default" type="button" uk-close="uk-close" />
            <h3 className="uk-modal-title">다시보기 목록 관리</h3>

            {/* 액션 나열 + progressive disclosure — 클릭 시 해당 입력 박스를 펼친다. 모달에 탭을 두지 않는다 (모달은 한 흐름). */}
            <button className="uk-button uk-button-default uk-width-1-1 uk-text-left" type="button" onClick={() => this.onExportClick()}>
              <span uk-icon="icon: upload; ratio: 0.8" className="uk-margin-small-right" />내보내기
            </button>
            {
              this.state.expanded === 'export' &&
              <div className="uk-margin-small-top uk-margin-small-bottom">
                <p className="uk-text-small uk-text-muted uk-margin-remove-top">지금 목록을 복사해 다른 기기·브라우저로 옮깁니다 (아래 텍스트가 클립보드에 복사됐어요)</p>
                <textarea className="uk-textarea" readOnly rows={5} value={this.state.exportedText} onFocus={e => e.target.select()} />
              </div>
            }

            <button className="uk-button uk-button-default uk-width-1-1 uk-text-left uk-margin-small-top" type="button" onClick={() => this.onImportClick()}>
              <span uk-icon="icon: download; ratio: 0.8" className="uk-margin-small-right" />가져오기
            </button>
            {
              this.state.expanded === 'import' &&
              <div className="uk-margin-small-top uk-margin-small-bottom">
                <p className="uk-text-small uk-text-muted uk-margin-remove-top">다른 기기에서 내보낸 텍스트를 붙여넣고 가져오기를 누르세요</p>
                <textarea className="uk-textarea" rows={5}
                  placeholder="여기에 붙여넣기"
                  value={this.state.importInput}
                  onChange={e => this.setState({ importInput: e.target.value })} />
                <button className="uk-button uk-button-small uk-button-primary uk-margin-small-top" type="button" onClick={() => this.onImport()}>가져오기</button>
              </div>
            }

            {
              this.state.message &&
              <div className="uk-alert uk-alert-primary uk-text-small uk-margin-top" style={{ padding: '0.6em 1em' }}>{this.state.message}</div>
            }

            <hr className="uk-margin" />

            <button className="uk-button uk-button-danger uk-button-small" type="button" onClick={() => this.onReset()}>목록 비우기</button>
          </div>
        </div>
      </div>
    );
  }
}

@observer
export class BookmarkComponent extends Component {
  get isBookmarked() {
    return 0 <= bookmark.getIndex(this.props.post)
  }

  async onBookmark() {
    console.log('on bookmark', { post: this.props.post })
    try {
      if (bookmark.has(this.props.post)) {
        bookmark.del(this.props.post)
      } else {
        bookmark.add(this.props.post)
      }
    } catch (e) {
      notify('저장 공간이 부족해 다시보기 목록을 저장하지 못했습니다', 'danger')
    }
  }
  render() {
    return (
      <div className="uk-flex uk-flex-middle">
        <a
          className="post-body uk-link-text uk-text-truncate uk-text-normal"
          href={this.props.post.url}
          style={{ flexGrow: 1 }}
          {...historyLinkProps(this.props.post)}>
          {this.props.post.subject}
        </a>
        <a
          className={`bookmark-icon ${bookmark.has(this.props.post) ? 'bookmarked' : 'not-bookmarked'} uk-icon-button uk-text-light uk-text-center uk-text-middle`}
          uk-icon="bookmark"
          style={{ flexShrink: 0, width: '2em', height: '2em' }}
          onClick={() => this.onBookmark()} />
        <span
          className={`badge-${PublisherStr[this.props.post.publisher]} uk-badge uk-text-nowrap uk-text-small uk-text-light`}
          style={{ marginLeft: '0.2em', flexShrink: 0 }} >
          {PublisherDisplayStr[this.props.post.publisher]}
        </span>
      </div>
    )
  }
}
